import { Check, Clock, Lock, Trash2, Upload } from "lucide-react";

import {
  ATTACHMENT_ACTIONS_ENUM,
  /* REVIEW_STATUS_ENUM, */
  SERVER_ORIGIN,
  STATUSES,
} from "../consts";

export default function SubmitCell({
  accept,
  status,
  link,
  fileName,
  /* reviewStatus, */
  attachmentActions,
  onFile,
  onDelete,
  onHistory,
  /* checkIsPlacementAllowed,
  checkIsOverdue, */
}) {
  const inputElem = (
    <input
      type="file"
      accept={accept}
      hidden
      onChange={(e) => e.target.files[0] && onFile(e.target.files[0])}
    />
  );

  const renderAddButton = () => {
    return (
      <label className="btn tiny" title="Загрузить новую версию">
        +{inputElem}
      </label>
    );
  };

  const renderDeleteButton = () => {
    /* if (
      reviewStatus?.code === REVIEW_STATUS_ENUM.onReview &&
      status !== STATUSES.closed
    ) { */
    return (
      <button
        className="icon-btn danger"
        onClick={onDelete}
        aria-label="Удалить"
      >
        <Trash2 size={14} />
      </button>
    );
    /* } */
  };

  /* const shouldRenderButtons = () =>
    status !== STATUSES.upcoming &&
    checkIsPlacementAllowed() !== false &&
    !checkIsOverdue(); */

  const renderContent = () => {
    if (link) {
      /* let addButton;
      let deleteButton;
      if (shouldRenderButtons()) {
        addButton = renderAddButton();
        deleteButton = renderDeleteButton();
      } */

      return (
        <div className="attachment-container">
          <div>
            <a className="link" href={`${SERVER_ORIGIN}${link}`}>
              <Check size={12} /> {fileName}
            </a>
            {attachmentActions?.some(
              (elem) => elem === ATTACHMENT_ACTIONS_ENUM.delete,
            ) && renderDeleteButton()}
          </div>
          {attachmentActions?.some(
            (elem) => elem === ATTACHMENT_ACTIONS_ENUM.addVersion,
          ) && renderAddButton()}
          <button className="btn tiny" onClick={onHistory}>
            История
          </button>
        </div>
      );
    }

    if (
      attachmentActions?.some((elem) => elem === ATTACHMENT_ACTIONS_ENUM.upload)
    ) {
      // if (status === STATUSES.open || shouldRenderButtons())
      return (
        <label className="btn tiny">
          <Upload size={12} /> Загрузить
          {inputElem}
        </label>
      );
    }

    return (
      <span className="muted small locked">
        {status === STATUSES.closed ? (
          <>
            <Lock size={12} /> закрыто
          </>
        ) : (
          <>
            <Clock size={12} /> скоро
          </>
        )}
      </span>
    );
  };

  return <div className="submit-cell">{renderContent()}</div>;
}
